import { YesNo } from '../enums';

export const YesNos = [
  { name: 'Yes', value: YesNo.Yes },
  { name: 'No', value: YesNo.No },
];
